import AuthService from "src/services/authService";
import { getReduxVersion } from "src/services/configService";
import { RootState } from "src/store";

import { createSlice } from "@reduxjs/toolkit";
import TimeService from "@services/timeService/timeService";

const currentUser = AuthService.getCurrentUser();
const currentSession = AuthService.getSession();
const currentReduxVersion = getReduxVersion();
const isTotpValid = AuthService.isUserTotpValid();

const initialState = {
    token: currentSession?.access_token || null,
    hasTotp: !!currentUser?.tft,
    isTotpValid,
    reduxVersion: currentReduxVersion,
    tokenExpiresAt: currentSession?.expires_at || null,
    refreshTokenExpiresAt: currentSession?.refresh_token_expires_at || null,
};

const slice = createSlice({
    name: "auth",
    initialState,
    reducers: {},
});

const selectIsTokenStale = (state: RootState) => {
    const now = TimeService.getNow();

    if (state.auth.refreshTokenExpiresAt) {
        return TimeService.getFromISO(state.auth.refreshTokenExpiresAt) < now;
    }
    if (state.auth.tokenExpiresAt) {
        return TimeService.getFromISO(state.auth.tokenExpiresAt) < now;
    }

    return true;
};

export const selectIsUserCredentialValid = (state: RootState) => {
    const tokenIsStale = selectIsTokenStale(state);
    const isCredentialInvalid = tokenIsStale || (state.auth.hasTotp && !state.auth.isTotpValid);
    return !isCredentialInvalid;
};

export default slice.reducer;
